module.exports = __webpack_public_path__ + "static/media/icon_map2.2ecb9938.svg";